import React from 'react'
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import classNames from 'classnames'
import swal from "sweetalert"

import Tooltip from "components/Tooltip"

import {
    updateVisualizationSelection,
    showStoredGraph,
    hideStoredGraph,
    renameStoredGraph,
    deleteStoredGraph,
    deleteAllStoredGraphs,
    storeCurrentGraph,
} from "search-new/action-creators"
import * as webSelectors from 'search-new/selectors'
import GenericTable from "components/GenericTable"

import { formatNumberForDisplay, toggleValue } from 'shared/imports/sharedHelperFunctions'

/* ***********************************************************************
* GOOD OL' LIST TABLE
************************************************************************ */

export const VisualizationResultsRow = (props) => {
    const _onClick = () => {
        if (props.onRowClick) {
            props.onRowClick(props.datum.id)
        }
    }

    return (
        <div
            className={classNames(
                "visualization-results-row",
                { active: props.datum.active }
            )}
            onClick={_onClick}
        >
            <div className='left'>{props.index + 1})</div>
            <div className='center'>{props.datum.long_display}</div>
            <div className='right'>{formatNumberForDisplay(props.datum.value)}</div>
        </div>
    )
}

export const UnconnectedVisualizationResultsTable = (props) => {
    const onRowClick = (value) => {
        if (props.noConnectedFilter) {
            return
        }

        const newSelectedValues = toggleValue(props.selectedValues, value)
        props.updateVisualizationSelection(props.uniqueFlvId, props.uniqueVizSceneId, newSelectedValues)
    }

    const tooltip = props.tooltipText && (
        () => (
            <Tooltip label={props.tooltipText}>
                <i className="fa fa-info-circle" />
            </Tooltip>
        )
    )

    return (
        <GenericTable
            {...props}
            data={
                props.isVisualizationLoading
                    ? []
                    : props.data || props.tableData
            }
            isLoading={props.isVisualizationLoading}
            onRowClick={props.onRowClick || onRowClick}
            rowComponent={VisualizationResultsRow}
            tableClassName="visualization-table"
            rightHeaderComponent={tooltip}
        />
    )
}

const vizResultsTableMapStateToProps = (state, props) => ({
    selectedValues: webSelectors.selectVisualizationSelectedValues(state, props),
    tableData: webSelectors.selectVisualizationTableData(state, props),
    isVisualizationLoading: webSelectors.selectIsVisualizationLoading(state, props),
})

export const VisualizationResultsTable = connect(vizResultsTableMapStateToProps, { updateVisualizationSelection })(UnconnectedVisualizationResultsTable)

/* ***********************************************************************
* VISUALIZATION LAYER TABLE
************************************************************************ */

export const LayerRow = (props) => {
    const icon = props.datum.active
        ? 'fa-check-square-o'
        : 'fa-square-o'

    const toggleGraph = () => props.onLeftClick(props.datum.id, props.datum.active)
    const deleteGraph = () => props.onRightClick(props.datum.id)
    const renameLayer = () => props.onCenterClick(props.datum.id)

    return (
        <div className="visualization-results-row viz-layer">
            <div className='left icon-container' onClick={toggleGraph}>
                <i className={`fa ${icon} hoverable`} />
            </div>
            <Tooltip label="Double click to rename layer.">
                <div className='center center-text' onDoubleClick={renameLayer}>
                    {props.datum.label}
                </div>
            </Tooltip>
            <div className='right icon-container' onClick={deleteGraph}>
                <Tooltip label="Delete this stored graph.">
                    <i className='fa fa-minus-circle hoverable' />
                </Tooltip>
            </div>
        </div>
    )
}

export const UnconnectedVisualizationLayerTable = (props) => {

    const storeCurrentGraph = () =>
        !props.disabled && props.storeCurrentGraph(props.uniqueFlvId, props.uniqueVizSceneId)

    const deleteAllStoredGraphs = () =>
        !props.disabled && props.deleteAllStoredGraphs(props.uniqueFlvId, props.uniqueVizSceneId)

    const deleteGraph = (id) => {
        props.deleteStoredGraph(props.uniqueFlvId, props.uniqueVizSceneId, id)
    }

    const toggleGraph = (id, isActive) => {
        return isActive
            ? props.hideStoredGraph(props.uniqueFlvId, props.uniqueVizSceneId, id)
            : props.showStoredGraph(props.uniqueFlvId, props.uniqueVizSceneId, id)
    }

    const renameLayer = (id) => {
        props.renameStoredGraph(props.uniqueFlvId, props.uniqueVizSceneId, id)
    }

    const storeGraphComponent = () => (
        <Tooltip label="Save the current graph as a layer to compare to other results.">
            <i className="fa fa-plus hoverable" onClick={storeCurrentGraph} />
        </Tooltip>
    )

    const deleteGraphsComponent = () => (
        <Tooltip label="Delete all stored graphs.">
            <i className="fa fa-trash-o hoverable" onClick={deleteAllStoredGraphs} />
        </Tooltip>
    )


    return (
        <GenericTable
            data={props.tableData}
            rowComponent={LayerRow}
            tableClassName='visualization-table'
            label="Saved Graphs"
            leftHeaderComponent={storeGraphComponent}
            rightHeaderComponent={deleteGraphsComponent}
            onLeftClick={toggleGraph}
            onCenterClick={renameLayer}
            onRightClick={deleteGraph}
            noDataText="Click the + button to save a graph."
        />
    )
}

const vizLayerTableMapStateToProps = (state, props) => ({
    tableData: webSelectors.selectStoredGraphTableData(state, props)
})

const layerActions = {
    showStoredGraph,
    hideStoredGraph,
    renameStoredGraph,
    deleteStoredGraph,
    deleteAllStoredGraphs,
    storeCurrentGraph
}

export const VisualizationLayerTable = connect(vizLayerTableMapStateToProps, layerActions)(UnconnectedVisualizationLayerTable)

